import React, { Component } from 'react';

class Notifications extends Component {
    state = {
        notifications: [],
        loading: true,
        error: null,
        showDropdown: false
    };

    componentDidMount() {
        this.fetchNotifications();
    }

    fetchNotifications = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/api/account/notifications`;
            
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache': 'no-cache'
                }
            });
            
            const result = await response.json();
            
            if (result.msg === 'Notifications') {
                this.setState({ 
                    notifications: result.notifications,
                    unreadCount: result.unread_count,
                    loading: false 
                });
            } else {
                this.setState({ loading: false });
            }
        } catch (error) {
            this.setState({ 
                error: 'Error fetching notifications',
                loading: false 
            });
        }
    };

    toggleDropdown = () => {
        this.setState(prevState => ({
            showDropdown: !prevState.showDropdown
        }));
    };

    getNotificationIcon = (type) => {
        switch (type) {
            case 'success':
                return '✓';
            case 'warning':
                return '⚠';
            case 'error':
                return '✕';
            case 'info':
            default:
                return 'ℹ';
        }
    };

    getNotificationClass = (type) => {
        switch (type) {
            case 'success':
                return 'notification-success';
            case 'warning':
                return 'notification-warning';
            case 'error':
                return 'notification-error';
            case 'info':
            default:
                return 'notification-info';
        }
    };

    formatTime = (timeString) => {
        if (!timeString) return '';
        
        const date = new Date(timeString);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMins / 60);
        const diffDays = Math.floor(diffHours / 24);
        
        if (diffMins < 1) return 'Just now';
        if (diffMins < 60) return `${diffMins}m ago`;
        if (diffHours < 24) return `${diffHours}h ago`;
        if (diffDays < 7) return `${diffDays}d ago`;
        
        return date.toLocaleDateString();
    };

    render() {
        const { notifications, loading, showDropdown, unreadCount } = this.state;

        return (
            <div className="notifications-container">
                <button 
                    className="notifications-toggle"
                    onClick={this.toggleDropdown}
                    aria-label="Notifications"
                >
                    <span className="bell-icon">🔔</span>
                    {unreadCount > 0 && (
                        <span className="notification-badge">{unreadCount}</span>
                    )}
                </button>
                
                {showDropdown && (
                    <div className="notifications-dropdown">
                        <div className="notifications-header">
                            <h4>Notifications</h4>
                            {unreadCount > 0 && (
                                <span className="unread-count">{unreadCount} unread</span>
                            )}
                        </div>
                        
                        <div className="notifications-list">
                            {loading ? (
                                <div className="notification-item loading">
                                    Loading...
                                </div>
                            ) : notifications.length === 0 ? (
                                <div className="notification-item empty">
                                    No notifications
                                </div>
                            ) : (
                                notifications.map(notification => (
                                    <div 
                                        key={notification.id}
                                        className={`notification-item ${this.getNotificationClass(notification.type)} ${notification.read ? 'read' : 'unread'}`}
                                    >
                                        <div className="notification-icon">
                                            {this.getNotificationIcon(notification.type)}
                                        </div>
                                        <div className="notification-content">
                                            <h5 className="notification-title">
                                                {notification.title}
                                            </h5>
                                            <p className="notification-message">
                                                {notification.message}
                                            </p>
                                            <span className="notification-time">
                                                {this.formatTime(notification.time)}
                                            </span>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                        
                        <div className="notifications-footer">
                            <button className="btn-link">View All</button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Notifications;

